import 'bootstrap/dist/css/bootstrap.min.css';

export const MyNavbar = () => {
    return (
        <>
            <div className="whole-nav">
                <nav className="navbar navbar-expand-lg sticky-top" style={{ height: '80px', backgroundColor: '#fefefe', boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)' }}>
                        <a className="navbar-brand" href="/" style={{ paddingLeft: '25px' }}>
                            <picture>
                                <img src="/lone-wolf-writes-logo.jpg" alt=" Logo | Lone Wolf writes " style={{ width: '150px' }} />
                            </picture>
                        </a>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation" style={{marginRight:"20px"}}>
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse justify-content-end" id="navbarNavDropdown" style={{ zIndex: '999', width:'100%', backgroundColor: '#fefefe', paddingRight:"40px" }}>
                            <ul className="navbar-nav">
                                <li className="nav-item active">
                                    <a className="nav-link" href="/" style={{ fontSize: 'large', textAlign:'center' }}>Home <span className="sr-only"></span></a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/blogs" style={{ fontSize: 'large', textAlign:'center'  }}>Blogs</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/about" style={{ fontSize: 'large', textAlign:'center'  }}>About Us</a>
                                </li>
                                <li className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" href="/" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ fontSize: 'large', textAlign:'center'  }}>
                                        Writings
                                    </a>
                                    <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink" style={{ fontSize: 'large', margin: '10px 20px', boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)' }}>
                                        <a className="dropdown-item" href="/quotes" style={{ fontSize: 'large', textAlign:'center'  }}>Quotes</a>
                                        <a className="dropdown-item" href="/poems-eng"  style={{ fontSize: 'large', textAlign:'center'  }}>Poems</a>
                                        <a className="dropdown-item" href="/poems-mar"  style={{ fontSize: 'large', textAlign:'center'  }}>कविता</a>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/contact" style={{ fontSize: 'large', textAlign:'center'  }}>Contact Us</a>
                                </li>
                            </ul>
                        </div>
                </nav>
            </div>
        </>
    )
}
